/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Architecture12Inputs */

const en_job_form_enum_architecture12 = /** @type {(inputs: Job_Form_Enum_Architecture12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture`)
};

const de_job_form_enum_architecture12 = /** @type {(inputs: Job_Form_Enum_Architecture12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architektur`)
};

/**
* | output |
* | --- |
* | "Architecture" |
*
* @param {Job_Form_Enum_Architecture12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_architecture12 = /** @type {((inputs?: Job_Form_Enum_Architecture12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Architecture12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_architecture12(inputs)
	return en_job_form_enum_architecture12(inputs)
});
export { job_form_enum_architecture12 as "job_form_enum_ARCHITECTURE" }